import React from 'react';

interface ChartTooltipCardProps {
  year: string | number;
  metricLabel: string;
  value: string;
}

export const ChartTooltipCard: React.FC<ChartTooltipCardProps> = ({ year, metricLabel, value }) => {
  return (
    <div className="bg-white p-2 border border-gray-200 rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-2 gap-1">
        <span style={{ fontSize: '12px', fontWeight: 400 }} className="text-black">Year:</span>
        <span style={{ color: '#3B50A2', fontSize: '12px', fontWeight: 500 }} className="font-semibold">{year}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span style={{ fontSize: '12px', fontWeight: 400 }} className="text-black">{metricLabel}:</span>
        <span style={{ color: '#3B50A2', fontSize: '12px', fontWeight: 500 }} className="font-semibold">{value}</span>
      </div>
    </div>
  );
}; 